export const ZERO_DELTA = { deltaLat: 0, deltaLng: 0 };
export const NUDGE_STEP_METERS = 0.1;
export const NUDGE_STEP_LARGE_METERS = 1;
export const MAX_SHIFT_DELTA_DEGREES = 0.00089831;

const METERS_PER_DEGREE_LAT = 111320;

const cosLat = (refLat) => Math.cos((refLat * Math.PI) / 180);

export const metersToDelta = (northMeters, eastMeters, refLat) => ({
  deltaLat: northMeters / METERS_PER_DEGREE_LAT,
  deltaLng: eastMeters / (METERS_PER_DEGREE_LAT * cosLat(refLat)),
});

export const deltaToMeters = (delta, refLat) => ({
  north: (delta?.deltaLat ?? 0) * METERS_PER_DEGREE_LAT,
  east: (delta?.deltaLng ?? 0) * METERS_PER_DEGREE_LAT * cosLat(refLat),
});

export const addDelta = (a, b) => ({
  deltaLat: (a?.deltaLat ?? 0) + (b?.deltaLat ?? 0),
  deltaLng: (a?.deltaLng ?? 0) + (b?.deltaLng ?? 0),
});

export const inverseDelta = (d) => ({
  deltaLat: -(d?.deltaLat ?? 0),
  deltaLng: -(d?.deltaLng ?? 0),
});

export const isZeroDelta = (d) => !d || (d.deltaLat === 0 && d.deltaLng === 0);

export const exceedsMaxDelta = (d) =>
  Math.abs(d?.deltaLat ?? 0) > MAX_SHIFT_DELTA_DEGREES ||
  Math.abs(d?.deltaLng ?? 0) > MAX_SHIFT_DELTA_DEGREES;

export const distanceMeters = (delta, refLat) => {
  const { north, east } = deltaToMeters(delta, refLat);
  return Math.sqrt(north * north + east * east);
};

export const formatOffset = (delta, refLat) => {
  if (isZeroDelta(delta)) return "No offset";
  const { north, east } = deltaToMeters(delta, refLat);
  const parts = [];
  if (Math.abs(east) >= 0.05) {
    parts.push(`${Math.abs(east).toFixed(1)} m ${east > 0 ? "East" : "West"}`);
  }
  if (Math.abs(north) >= 0.05) {
    parts.push(
      `${Math.abs(north).toFixed(1)} m ${north > 0 ? "North" : "South"}`
    );
  }
  if (!parts.length) return "No offset";
  return `${parts.join(" · ")} (${distanceMeters(delta, refLat).toFixed(
    1
  )} m total)`;
};
